import type { ReactNode } from 'react';

export function Checkbox({
  checked = false,
  onChange,
  label,
}: {
  checked?: boolean;
  onChange?: (next: boolean) => void;
  label?: ReactNode;
}) {
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        cursor: 'pointer',
        fontFamily: 'var(--font-vi)',
        fontSize: 14,
        color: 'var(--ink)',
      }}
    >
      <span
        onClick={() => onChange?.(!checked)}
        style={{
          width: 22,
          height: 22,
          borderRadius: 6,
          flexShrink: 0,
          border: checked ? 'none' : '1.5px solid var(--border-default)',
          background: checked ? 'var(--cta-default)' : 'var(--surface-page)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: 14,
        }}
      >
        {checked ? '✓' : ''}
      </span>
      {label}
    </label>
  );
}
